document.addEventListener(
  "gform_after_submission",
  function (event, formId) {
    // Check if the correct form ID, adjust '1' to your form's ID
    if (formId == 1) {
      // Define the event parameters
      var gaEventParams = {
        event_name: "submit_form",
        event_params: {
          form_name: "Contact Form",
          location: window.location.href,
        },
      };

      // Send event to Google Analytics 4
      gtag("event", gaEventParams.event_name, gaEventParams.event_params);
    }
  },
  false,
);
